import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/containers/PressReleasePage/index.tsx");
